import { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageLoading from "../../../../components/_atom/loading/PageLoading";
import TableStatusLabel from "../../../../components/_atom/label/TableStatusLabel";
import Table from "../../../../../legacy-common/atom/table/Table";
import { ALL_MAIN_STATUS } from "../../../../../constants/commonConstants";
import { errorAlert } from "../../../../../utils/Utils";
import Section from "legacy-common/atom/section/Section";
import { getWalletListAction } from "../../../../../action/walletAction";
import { selected_project_id } from "reducer/projectReducer";
import PageTitle from "view/components/_molecules/page/PageTitle";
import PageArticle from "view/components/_template/page/PageArticle";
import BasicButton from "view/components/_atom/button/BasicButton";
import { ButtonSize, ButtonTheme } from "view/components/_atom/button/StyledButton";
import useLoading from "hooks/useLoading";

function WalletList(props) {
  const navigate = useNavigate();

  const projectId = useSelector(selected_project_id);

  const [walletList, setWalletList] = useState([]);

  const getWalletList_ = async () => {
    const { result, error } = await getWalletListAction({ projectId, mainStatus: ALL_MAIN_STATUS });

    if (result) {
      setWalletList(result);
    }
    if (error) {
      errorAlert(error.data.message);
    }
  };

  const headers = useMemo(
    () => [
      { title: "No", accessor: "id" },
      { title: "Network", accessor: "network" },
      { title: "Microchain", accessor: "microChain" },
      { title: "Type", accessor: "type" },
      { title: "Status", accessor: "status" },
    ],
    []
  );

  const renderer = useCallback(
    (data) => ({
      id: data.microChainAssetId,
      network: data.networkLabel,
      microChain: data.microChainLabel,
      type: data.type,
      // type: WALLET_TYPE_LIST.find((el) => el.id === data.assetId)?.label ?? "Coin & Token",
      status: <TableStatusLabel mainStatus={data.mainStatus} subStatus={data.subStatus} custom={[{ status: 5, style: 5, text: "Deployed" }]} />,
    }),
    []
  );

  const colGroup = useMemo(() => [10, 25, 25, 20, 20].map((el) => ({ style: { width: `${el}%` } })), []);

  const onWalletClick = (el, index) => {
    navigate(`${el.microChainAssetId}`);
  };

  const onCreateWallet = () => {
    navigate("/tool/wallet/register");
  };

  const walletListView = () => [
    {
      renderers: [
        {
          value: <Table headers={headers} data={walletList} renderer={renderer} colGroup={colGroup} onClick={onWalletClick} />,
        },
      ],
    },
  ];

  const { loading } = useLoading({
    dependency: [projectId],
    synchronousFunction: async () => {
      await getWalletList_();
    },
  });

  if (loading) {
    return <PageLoading />;
  }

  return (
    <PageArticle>
      <PageTitle size={1240} title={"Wallet List"} description={"Register and manage your wallets."} />
      <div className="page-layout-1240">
        <BasicButton theme={ButtonTheme.CREATE} size={ButtonSize.EXTRALARGE} onClick={() => onCreateWallet()}>
          Register in Wallet
        </BasicButton>
        <div style={{ height: 30 }} />
        <Section title={"Wallet"} view={walletListView} />
      </div>
    </PageArticle>
  );
}

export default WalletList;
